export default "__VITE_ASSET__b3d77388__"